var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
  'timer',
  {
    expired: _vm.countdown < 0,
    neutral: _vm.countdown === null
  }
]},[_vm._v(" "+_vm._s(_vm.formatCountdown(_vm.countdown))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }